module.exports = __webpack_public_path__ + "static/img/al3.cfaf5b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al3.jpg
// module id = POG0
// module chunks = 1